import { CurrencyExchangeRates } from '@/types';
import { fetchCurrencyExchangeRates } from '@/utils/http/fetchCurrencyExchangeRates';
import { Thunk } from '@/redux/types';
import { CoreActionTypes, CurrencyExchangeRatesFetchAction } from '../types';

export const fetchCurrencyExchangeRatesAction =
  (): Thunk<Promise<void>, CurrencyExchangeRatesFetchAction> => (dispatch) =>
    fetchCurrencyExchangeRates().then((rates) => {
      const payload = rates.exchangePairs.reduce<CurrencyExchangeRates>(
        (ratesMap, { exchangeRate, termsCurrency: { id: currencyId } }) => {
          ratesMap[currencyId] = exchangeRate;
          return ratesMap;
        },
        {}
      );
      dispatch({ type: CoreActionTypes.CURRENCY_EXCHANGE_RATES_FETCH, payload });
    });
